import { DotsThreeVertical } from "@phosphor-icons/react";

import { Button } from "common/components/ui/Button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuList,
  DropdownMenuTrigger,
} from "common/components/ui/DropdownMenu";
import { typedObjectEntries } from "common/helpers/utils";
import type { Member } from "common/types";

import useMembersActions from "../../../hooks/useMembersActions";

interface MemberActionsDropdownProps {
  member: Member;
  setAction: (
    newAction: keyof ReturnType<typeof useMembersActions>["actions"],
  ) => void;
}

export default function MemberActionsDropdown({
  member,
  setAction,
}: MemberActionsDropdownProps) {
  const { actions } = useMembersActions(member);

  const dropdownMenuComponent = (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button intent="iconOnly" variant="secondary-black" size="sm">
          <DotsThreeVertical />
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end" size="sm">
        <DropdownMenuList>
          {typedObjectEntries(actions).map(
            ([key, { icon: Icon, label, isDanger }]) => (
              <DropdownMenuItem
                key={key}
                onSelect={() => {
                  setAction(key);
                }}
                variant={isDanger ? "danger" : "default"}
              >
                <Icon />
                {label}
              </DropdownMenuItem>
            ),
          )}
        </DropdownMenuList>
      </DropdownMenuContent>
    </DropdownMenu>
  );

  if (Object.keys(actions).length) {
    return dropdownMenuComponent;
  }
}
